<template>
<v-content>
  <v-container fluid fill-height>
    <v-layout align-center justify-center>
      <v-flex xs12 sm8 md4>
        <p class="text-center">
          ERP VALUE!<br/>
          デモ版 ログイン
        </p>
        <v-card flat>
          <v-form @submit.prevent="login">
            <v-card-text>
              <v-text-field ref="username" prepend-icon="person" name="username" label="メールアドレス" type="text" v-model="editedItem.username" :rules="[rules.required]"></v-text-field>
              <v-text-field ref="password" id="password" prepend-icon="lock" name="password" label="パスワード" type="password" v-model="editedItem.password" :rules="[rules.required]"></v-text-field>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn dark type="submit" color="primary" :loading="loading">
                <v-icon left>fas fa-sign-in-alt</v-icon>ログイン
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</v-content>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/database'

export default {
  data() {
    return {
      editedItem: {
        username: null,
        password: null,
      },
      loading: false,
    }
  },
  props: {

  },
  computed: {
    form() {
      let form = Object.assign({}, this.editedItem)
      return form
    }
  },
  methods: {
    login() {
      let validate = true
      Object.keys(this.form).forEach(f => {
        if (!this.$refs[f].validate(true)) validate = false
      })

      if (validate) {
        this.loading = true
        firebase.auth().signInWithEmailAndPassword(this.editedItem.username, this.editedItem.password).then(() => {
          this.log(this.editedItem.username, 'ログイン: 成功')
          this.success()
        }).catch(error => {
          this.log(this.editedItem.username, 'ログイン: ' + error)
          this.invalid('メールアドレスまたはパスワードが間違っています。')
        })
        /*
        firebase.database().ref('users').orderByChild('email').equalTo(this.editedItem.username).once('value').then((doc) => {

          if (doc.val().passwd === this.editedItem.password) {
            this.$http.get('/login', {
              params: {
                uid: this.editedItem.username
              }
            }).then((res) => {
              firebase.auth().signInWithCustomToken(res.data.token).then(() => {
                this.log(this.editedItem.username, 'ログイン: 成功')
                this.success()
              }).catch((error) => {
                this.log(this.editedItem.username, 'ログイン: ' + error)
                this.invalid('認証に失敗しました')
              })
            }).catch((error) => {
              this.log(this.editedItem.username, 'ログイン: ' + error)
              this.invalid('通信エラーが発生しました')
            })
          } else {
            this.log(this.editedItem.username, 'ログイン: パスワード認証エラー')
            this.invalid('パスワードが間違っています')
          }

        }).catch(() => {
          this.log(this.editedItem.username, 'ログイン: 社員コードが未登録')
          this.invalid('社員コードが登録されていません')
        })
        */
      }
    },
    success() {
      this.$router.push('/')
    },
    invalid(mess) {
      this.editedItem.password = ''
      this.loading = false
      this.myAlert(mess)
    }
  }
}
</script>

<style scoped>
.signin {
  display: flex;
  justify-content: center;
  align-items: center;
}

ul.list-inline {
  list-style: none;
  margin: 0;
  padding: 0;
}

ul.list-inline>li {
  display: inline-block;
  padding: 0 10px;
}
</style>
